/**
 * 区域组件：只出现目前有仓库的国家下拉
 * @Author: fjj
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2024.08.13      1.0     First version
 *
 * @param onCountryClicked  当点击后回调(CountryId)
 * @param onCityClicked   选择城市 回调城市数组
 *
 * Copyright 2022, all rights reserved. Essa.cn
 */
import React,{PureComponent} from 'react';
import { Form, Row, Col, Select } from 'antd';
import { isEmpty,isEmptyObject } from "@utils/utils";
import RegionService from "./Region.action";
import PropTypes from "prop-types";
import Lang from "@/components/Lang/Lang";
const { Option } = Select;
const FormItem = Form.Item;
export default class TransitCity extends PureComponent {
    static propTypes = {
        hidden: PropTypes.bool,
    }
    static defaultProps = {
        hidden:false,
        size:"default",
    }
    constructor(props) {
        super(props);
        this.state={
            listCountry :[],
            subList: [],
            loading: false,
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    deWeightList = (arr3) => {
        let map = new Map();
        for (let item of arr3) {
            if (!map.has(item.countryCode)) {
                map.set(item.countryCode, item);
            }
        }
        return [...map.values()];
    }
    /**
     * 请求地区列表
     * */
    getList(){
        const sUrl = "/service/mg/public/user/get-transit-city";
        this.loading(true)
        RegionService.postHttpAction(sUrl,{}).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    handleRes(resData){
        const { success, valid, models=[], } = resData;
        this.loading(false)
        if (success && valid) {
            if(models&&models.length>0){
                const list = this.deWeightList(models||[]);
                this.setState({
                    listCountry : list,
                })
            }
        }
    }
    /**
     * 请求城市列表
     * */
    getListCity(countryCode){
        const sUrl = "/service/mg/follower/query/city-by-country-code";
        this.loading(true)
        RegionService.postHttpAction(sUrl,{countryCode:countryCode}).then((resp)=>this.handleResCity(resp.data)).catch(err=>this.handleResCity(err));
    }
    handleResCity(resData){
        const { success, valid, models=[], } = resData;
        this.loading(false)
        if (success && valid) {
            if(models&&models.length>0){
                this.setState({
                    subList:models,
                })
            }
        }
    }
    /**
     * 选择国家
     * */
    handleCountryChange = (countryCode,option) => {
        if(countryCode){
            // const { listCountry } =this.state;
            // const current = listCountry.find(item=>item.code==value)||{}
            // const countryCode = current.code;
            // const subList = current.countryList||[];
            this.getListCity(countryCode)
            if(this.props.onChange)this.props.onChange(countryCode);
            if(this.props.clearSubRegion){this.props.clearSubRegion('cityCode');}
           this.setState({
               currentCountryCode :countryCode,
           })
        }else {
            if(this.props.onChange)this.props.onChange('');
            if(this.props.clearSubRegion){this.props.clearSubRegion('cityCode');}
            this.setState({
                currentCountryCode :'',
                subList: []
            })
        }
    };
    /**
     * 选择城市
     * */
    // handleCityChange =  (value,option) => {
    //     console.log("选择城市,optio",value,option)
    //     if(value) {
    //
    //     }else {
    //         console.log("清空城市",)
    //         if(this.props.clearSubRegion){
    //             this.props.clearSubRegion('cityCode');
    //         }
    //     }
    // };
    componentWillMount() {
        this.getList();
    }
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { disabled,required, formItemLayout,title,showSubTitle,hidden,size } = this.props;
        const { listCountry, subList, loading } = this.state;
        return (<>
                        <FormItem  {...formItemLayout}  name={'countryCode'} label={title}
                                   hidden={hidden}
                                   rules={[{ required:required? true:false, message: Lang({id:"QingXuanZeGuoJia2",default:"请选择国家"})}]}>
                            <Select showSearch
                                    size={size}
                                   disabled={disabled}
                                   filterOption={(input, option) =>option.text.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                   allowClear
                                   loading={loading}
                                   placeholder={Lang({id:"QingXuanZeGuoJia2",default:"请选择国家"})} //
                                   onChange={(value,option)=>this.handleCountryChange(value,option)} >
                            {listCountry.map(country => {
                                    const iconUrl = country.abbreviate?require('../../assets/img/country/'+country.abbreviate + '.png'):'';
                                    return (<Option key={country.countryCode+''} value={country.countryCode+''} text={country.countryName}>
                                        {iconUrl?<img src={iconUrl.default} height={10.5} className={"mr_8"} />:null} <span>{country.countryName}</span>
                                    </Option>)
                            })}
                        </Select>
                        {/*)}*/}
                        </FormItem>
                        <FormItem {...formItemLayout} name={'cityCode'} label={showSubTitle||' '}
                                  hidden={hidden}
                                  rules={[{ required:required? true:false, message: Lang({id:"QingXuanZeChengShi",default:"请选择城市"})}]}>
                            <Select size={size}
                                    showSearch
                                    filterOption={(input, option) =>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    allowClear
                                    disabled={disabled}
                                    // onChange={(value,option)=>this.handleCityChange(value,option)}
                                    placeholder={Lang({id:"QingXuanZeChengShi",default:"请选择城市"})}>
                                    {subList.map(city => (
                                        <Option key={city.code} value={city.code}>{city.name}</Option>
                                    ))}
                                </Select>
                            {/*)}*/}
                        </FormItem>
    </>)}
}

